import React from 'react';
import Translate from 'react-translate-component';
import { Button } from 'antd';

const ModalCloseButton = ({ close }) => (
    <Button onClick={close}>
        <Translate content="modal_settings.cancel" />
    </Button>
);

export default ModalCloseButton;
